import { gql } from '@apollo/client';
import { ErrorMessageInfo } from '@retainerclub/shared-api';

export default gql`
  mutation CreateProductTaxProfile($input: ProductTaxProfileCreateInput!) {
    createProductTaxProfile(input: $input) {
      clientMutationId
      errorMessages {
        ...ErrorMessageInfo
      }
      taxProfile {
        id
        productId
        state
      }
    }
  }
  ${ErrorMessageInfo}
`;
